import PropTypes from 'prop-types';
import React from 'react';

class ToggleButton extends React.Component {
  onChange = () => {
    this.props.onToggle(this.input.checked);
  };

  render() {
    return (
      <div className="ToggleButton">
        <input
          ref={node => {
            this.input = node;
          }}
          className="ToggleButton-checkbox"
          type="checkbox"
          id={this.props.name}
          onChange={this.onChange}
          defaultChecked={this.props.defaultChecked}
        />
        <label className="ToggleButton-label" htmlFor={this.props.name}>
          Toggle
        </label>
      </div>
    );
  }
}

ToggleButton.propTypes = {
  defaultChecked: PropTypes.bool,
  name: PropTypes.string.isRequired,
  onToggle: PropTypes.func.isRequired,
};

ToggleButton.defaultProps = {
  defaultChecked: false,
};

export default ToggleButton;



// WEBPACK FOOTER //
// ./src/js/components/ToggleButton.js